/** A single horizontal bar, scaled to `max`, with its value printed beside it. */
export function AnalyticsBar({
  value,
  max,
  label,
  tone,
}: {
  value: number;
  max: number;
  label: string;
  tone: "posted" | "expected" | "actual" | "count";
}) {
  const pct = max > 0 ? Math.max(2, (value / max) * 100) : 0;
  return (
    <div className="abar">
      <div className="abar-track">
        <div className={`abar-fill abar-${tone}`} style={{ width: `${pct}%` }} />
      </div>
      <span className="abar-value">{label}</span>
    </div>
  );
}
